<template>
    <div>
        <div class="alert alert-danger" v-if="error">
            {{ errorMessage }}
        </div>

        <form role="form">

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Title</label>

                <div class="col-md-8">
                    <input v-model="form.title" type="text" class="form-control" name="title"
                     :autofocus="!isEditing"
                     :class="{'is-invalid': form.errors.has('title')}" />
                    <span class="invalid-title" v-show="form.errors.has('title')">
                        @{{ form.errors.get('title') }}
                    </span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Description</label>

                <div class="col-md-8">
                    <textarea v-model="form.description" type="text" rows="5" class="form-control" name="description"></textarea>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Image</label>
                <div class="col-md-8">
                    <input :ref="templateImageRef" :id="templateImagePickerId" type="file" accept="image/*" class="spark-uploader-control hide-input" name="templateImage" @change="addImage" :disabled="form.busy" >
                    <button class="btn btn-light" @click="openFileDialog">{{ this.images.length > 0 ? "Add another image" : "Add an image" }}</button>
                </div>
                <div v-for="image in images" :key="image.id" class="offset-md-3 col-md-8">
                    <div class="row no-gutter">
                        <div class="col-md-12 image-file-group">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="image-file">{{ image.filename }} <span class="clickable ml-1 float-right" @click="cancelFile(image)"><i class="fa fa-times"></i></span></div>
                                </div>
                                <div class="col-md-6">
                                    <img id="localImagePreview" class="local-image-preview" :src="image.imageUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row mb-0">
                <div class="col-md-8 offset-md-3">
                    <button type="button" class="btn btn-info" @click="submit" :disabled="busy">{{saveButtonTitle}}</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: ['role', 'template', 'isEditing'],

        created: function() {

        },

        mounted: function() {

        },

        data: function() {
            return {
                form: new SparkForm({
                    title: this.template && this.template.title ? this.template.title : '',
                    description: this.template && this.template.description ? this.template.description : '',
                    cost: this.template && this.template.cost ? this.template.cost : 0,
                    image: null,
                    product_link: this.template && this.template.product_link ? this.template.product_link : '',
                    tax: 0,
                    project_id: null,
                }),
                error: false,
                errorMessage: '',

                images: this.getInitialImages(),
                imagesToDelete: [],

                busy: false
            };
        },

        computed: {
            templateImageRef: function() {
                return this.template ? this.template.id + '-templateImageRef' : 'templateImageRef';
            },

            templateImagePickerId: function() {
                return this.template ? this.template.id + '-templateImagePicker' : 'templateImagePicker';
            },

            saveButtonTitle: function() {
                if (this.isEditing) {
                    return "Update template";
                }

                return "Create template"
            }
        },

        watch: {

        },

        methods: {
            getInitialImages: function() {
                let images = [];
                if (this.template && this.template.images.length > 0) {
                    let images = [];
                    _.forEach(this.template.images, image => {
                        let imageData = {
                            id: image.id,
                            filename: image.filename,
                            imageUrl: image.url
                        };
                        images.push(imageData);
                    });
                    return images;
                }

                return images;
            },

            openFileDialog: function(e) {
                e.preventDefault();
                let id = '#' + this.templateImagePickerId;
                $(id).click();
            },

            cancelFile: function(image) {
                this.imagesToDelete.push(image);
                this.images = _.reject(this.images, imageInArray => imageInArray.imageUrl === image.imageUrl);
            },

            resetForm: function() {
                this.form = new SparkForm({
                    title: '',
                    description: '',
                    cost: null,
                    image: null,
                    tax: 0,
                    project_id: null,
                    product_link: '',
                    notifyCustomer: false
                });

                this.error = false;
                this.errorMessage = '';

                this.images = [];
                this.imagesToDelete = [];
            },

            addImage: function(e) {
                e.preventDefault();

                let file = this.$refs[this.templateImageRef].files[0];
                let image = {
                    image: file,
                    filename: file.name,
                    imageUrl: URL.createObjectURL(file)
                };
                this.images.push(image);
            },

            cancelForm: function() {
                this.resetForm();
                Bus.$emit('new-template-canceled');
            },

            newTemplateCreated: function(response) {
                this.resetForm();
                Bus.$emit('new-template-created', response);
                /*mixpanel.track('Template Created', {
                    title: response.title,
                });*/
            },

            templateUpdated: function(response) {
                Bus.$emit('template-updated', response);
                /*mixpanel.track('Template Updated', {
                    title: response.title,
                });*/
            },

            submit: function(e) {

                this.error = false;
                this.busy = true;

                if (this.isEditing) {
                    axios.post(`/api/changeorders/${this.template.id}/edit`, this.getFormData())
                        .then(response =>
                        {
                            this.templateUpdated(response.data);
                            this.busy = false;
                        })
                        .catch(error =>
                        {
                            this.error = true;
                            this.busy = false;
                            if (error.response) {
                                if (error.response.data.error) {
                                    this.errorMessage = error.response.data.error;
                                }
                                else if (error.response.status == 500) {
                                    this.errorMessage = 'Sorry, we had some trouble creating that template. Could you try again?';
                                }
                            }
                        });
                }
                else {
                    axios.post('/api/templates', this.getFormData())
                        .then(response => {
                            this.newTemplateCreated(response.data);
                            this.busy = false;
                        })
                        .catch(error => {
                            this.error = true;
                            this.busy = false;
                            if (error.response) {
                                if (error.response.data.error) {
                                    this.errorMessage = error.response.data.error;
                                }
                                else if (error.response.status == 500) {
                                    this.errorMessage = 'Sorry, we had some trouble creating that template. Could you try again?';
                                }
                            }
                        });
                }
            },

            getFormData: function() {
                const data = new FormData();
                data.append('is_template', true);
                data.append('title', this.form.title);
                data.append('description', this.form.description);

                _.forEach(this.images, image => {
                    if (image.image) {
                        data.append('images[][image]', image.image);
                        data.append('images[][filename]', image.filename);
                    }
                });

                _.forEach(this.imagesToDelete, image => {
                    if (image.id) {
                        data.append('images_to_delete[]', image.id);
                    }
                });

                return data;
            },
        }
    }
</script>
